var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPopulated2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 40 40",
    style: {
      enableBackground: "new 0 0 40 40"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\t.st0{fill:#73BE2F;}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M23.5,38.5h-7c-1.1,0-2-0.9-2-2v-11h-11c-1.1,0-2-0.9-2-2v-7c0-1.1,0.9-2,2-2h11v-11c0-1.1,0.9-2,2-2h7 c1.1,0,2,0.9,2,2v11h11c1.1,0,2,0.9,2,2v7c0,1.1-0.9,2-2,2h-11l0,11C25.5,37.6,24.6,38.5,23.5,38.5z M3.5,16.5v7h11c1.1,0,2,0.9,2,2 v11h7v-11c0-1.1,0.9-2,2-2h11v-7h-11c-1.1,0-2-0.9-2-2v-11h-7v11c0,1.1-0.9,2-2,2H3.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPopulated2);
export default __webpack_public_path__ + "static/media/populated2.382f5678bbea3f447daa42c559a408b8.svg";
export { ForwardRef as ReactComponent };